import { render, staticRenderFns } from "./PortalTimelineWidget.vue?vue&type=template&id=53a164a6&"
import script from "./PortalTimelineWidget.vue?vue&type=script&lang=ts&"
export * from "./PortalTimelineWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports